import { useMutation } from '@tanstack/react-query';
import { markComplianceNotified, complianceInvite } from '../services/banking';
import { useAppDispatch } from '../store/hooks';
import { setProductStatus } from '../store/companyUserSlice';

interface UseMarkComplianceNotifiedParams {
  companyId: number;
  productStatusId: number;
}

export const useMarkComplianceNotified = ({
  companyId,
  productStatusId,
}: UseMarkComplianceNotifiedParams) => {
  const dispatch = useAppDispatch();
  return useMutation({
    mutationFn: () => markComplianceNotified(companyId, productStatusId),
    onSuccess: (data) => {
      dispatch(setProductStatus(data));
    },
  });
};

export const useComplianceInvite = ({
  companyId,
  productStatusId,
}: UseMarkComplianceNotifiedParams) => {
  return useMutation({
    mutationFn: () => complianceInvite(companyId, productStatusId),
  });
};
